import { CustomButton } from '@Modules/core/components';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import CreationDatatableRowMeta from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/issuer/chargeback/creation/CreationDatatableRowMeta";

export type TCreationDatatableData = {
    primaryKey: string | number,
    TC: string,
    processingDate: string,  
    acquirerReferenceNumber: string,
    accountNumber: string,
    amount: string,
    currency: string,
    merchant: string,
    usage: string,
    selected: boolean,
    //
    message: string,
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
  handleDetails: (row: any) => void,
  displayDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TCreationDatatableData>()

export function getCreationDatatableColumns({ isLoading, handleEdit, handleDetails, displayDetails }: Props) {
  
  return [
    columnHelper.accessor("processingDate",
        {
            id: "processingDate",
            header: "Date de traitement",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("TC",
        {
            id: "TC",
            header: "TC",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("acquirerReferenceNumber",
        {
            id: "acquirerReferenceNumber",
            header: "Numero reference acquéreur",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("accountNumber",
        {
            id: "accountNumber",
            header: "Numero compte",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("amount",
        {
            id: "amount",
            header: "Montant facture",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("currency",
        {
            id: "currency",
            header: "Devise",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("merchant",
        {
            id: "merchant",
            header: "Commercant",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("usage",
        {
            id: "usage",
            header: "Usage",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("selected",
        {
            id: "selected",
            header: "Selectionné",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Checkbox checked={!!props.getValue()} readOnly></Checkbox>
                </Skeleton>)
            },
        }
    ),
    /************************** */
    columnHelper.accessor("message",
        {
            id: "message",
            header: "Message",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
            enableHiding: false,
        }
    ),

    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center display={'flex'} gap={5}>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleDetails(props.row)}                            
                        >
                            Details
                        </CustomButton>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleEdit(props.row)}                            
                        >
                            Edit
                        </CustomButton>
                        <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} />
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
